import Script from 'next/script';

const FaceShapeQuiz = () => {
	return (
		<>
			<div className='cf-cta-snippet cta181659' data-website-id='63378' data-cta-id='181659'></div>
			<Script id='faceShapeQuiz' type='text/javascript'>
				{`if (!window.convertflow) {
				var script = document.createElement("script");
				script.async = true;
				script.src = "https://js.convertflow.co/production/websites/63378.js";
				document.body.appendChild(script);
				};`}
			</Script>
		</>
	);
};

export default FaceShapeQuiz;
